import { Avatar, Box, Chip, Typography } from "@mui/material";

export const columns = [
  {
    field: "employeeName",
    headerName: "Employee Name",
    width: 400,
    renderCell: (params) => (
      <Box
        sx={{ display: "flex", alignItems: "center", gap: 1, padding: "8px" }}
      >
        <Avatar
          alt={params.value}
          src={`https://i.pravatar.cc/150?img=${params.row.id}`}
          sx={{ width: 32, height: 32 }}
        />
        <Typography>{params.value}</Typography>
      </Box>
    ),
  },
  { field: "deviceNumber", headerName: "Device Number", width: 180 },
  {
    field: "totalOrders",
    headerName: "Total Orders",
    width: 180,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "priorityOrders",
    headerName: "Priority Orders",
    width: 120,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "orderLines",
    headerName: "Order Lines",
    width: 140,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "totalItems",
    headerName: "Total Items",
    width: 200,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "status",
    headerName: "Status",
    width: 150,
    renderCell: (params) => {
      const status = params.value;

      return (
        <Chip
          label={status}
          sx={{
            borderRadius: "4px",
            fontSize: "12px",
            fontWeight: 300,
            color: status === "Present" ? "#3FC28A" : "#E19133",
            backgroundColor: status === "Present" ? "#3FC28A1A" : "#F45B691A",
          }}
        />
      );
    },
  },
];
